<template>
	<article class="list-item" :class="{active:open}">

		<div class="row baseline separated">

			<label class="field inline row">
			   	<span v-if="label" class="label rigid">{{label}}</span>
			   	<span class="row value">
					<div v-if="displayValue" class="display-text centered rigid">{{displayValue}}</div>
					<div class="display-text">
						<slot name="displayValue"></slot>
					</div>
				</span>
			</label>

			<span class="gap">
				<slot name="success-inline"></slot>
				<slot name="updating-inline"></slot>
			</span>

			<footer v-if="showEditControls" class="row rigid separated">
				<slot v-if="!open" name="action-link"></slot>
				<button class="link rigid centered" @click="toggleItem">
					<span v-if="open">{{buttonHideText}}</span>
					<span v-else>{{buttonShowText}}</span>
				</button>

			</footer>

		</div>

		<collapsible v-on:collapse-update="updateCollapsible" :min-height="minHeight" :data="collapsibleModel" :open="open">
			<slot class="row centering"></slot>
		</collapsible>

	</article>
</template>

<script>
import Collapsible from './Collapsible.vue';
export default {
	name: 'SettingExpand',
	components: {
		Collapsible
	},
	props: ['label', 'displayValue', 'buttonShowText', 'buttonHideText', 'inputRef', 'setActive', 'onOpen', 'onClose', 'minHeight', 'canEdit', 'setInactive', 'action'],
	data() {
		return {
			open: false,
			collapsibleModel: null
		};
	},
	computed: {
		showEditControls() {
			return this.canEdit === undefined || this.canEdit;
		}
	},
	methods: {
		toggleItem(e) {
			this.open = !this.open;

			if (this.open) {
				this.$root.$emit('active', this.inputRef);

				if (typeof this.onOpen === 'function') {
					this.onOpen();
				}
				return;
			}
			if (typeof this.onClose === 'function') {
				this.onClose();
			}

		},
		resetItem(e) {
			this.open = false;
		},
		updateCollapsible(list) {
			this.collapsibleModel = list;
		}
	},
	watch: {
		setActive(active, wasActive) {
			if (active) {
				this.toggleItem();
			}
		},
		setInactive(setInactive, wasInactive) {
			if (setInactive) {
				this.toggleItem();
			}
		}
	},
	mounted() {
		if (this.setActive) {
			this.toggleItem();
		}
	},
	created() {
		this.$root.$on('active', (ref) => {
			this.open = (this.inputRef === ref);

			if (!this.open) {
				this.resetItem();
			}
		});
	}
};

</script>



// WEBPACK FOOTER //
// ./src/components/SettingExpand.vue